import PropTypes from 'prop-types';
import TruckIcon from './TruckIcon';
import LfintTruckIcon from './lfint-TruckIcon';

const SITE_TRUCK_ICONS = {
  lfint: LfintTruckIcon,
  // Add more site-specific icons here as needed
};

export default function DynamicTruckIcon(props) {
  const IconComponent = SITE_TRUCK_ICONS[props.siteCode] || TruckIcon;
  return <IconComponent />;
}

DynamicTruckIcon.propTypes = {
  siteCode: PropTypes.string,
};
